import React, { useEffect, useState } from "react";
import NavBar from "../Components/NavBar/NavBar";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import NewSidebarOld from "../Components/NewComponents/NewSidebarOld";

const SIDEBAR_W = "w-24"; // 96px — must match NewSidebarOld's w-24

const HomeNew = () => {
  const navigate = useNavigate();
  const [showSideBar, setShowSideBar] = useState(true);

  const userData = JSON.parse(localStorage.getItem("BondTimeLoginUserData"));
  const isAuthenticated = userData && userData[0]?.Userlogin === "Sucess";

  useEffect(() => {
    if (!isAuthenticated) navigate("/");
  }, [isAuthenticated]);

  const toggleShowSideBar = () => setShowSideBar((p) => !p);

  return (
    <div className="h-screen overflow-y-auto  bg-[#F9FAFA]">

      {/* ── Sidebar — fixed, full height, sits BELOW navbar (z-10) ── */}
      <aside className="fixed top-0 left-0 h-screen w-24 z-10 bg-[#F9FAFA]">
        <NewSidebarOld />
      </aside>

      {/* ── Navbar — fixed, full width, sits ABOVE sidebar (z-20) ── */}
      <header className="fixed top-0 left-0 right-0 z-20 bg-[#F9FAFA] ">
        <NavBar toggleShowSideBar={toggleShowSideBar} />
      </header>

      {/* ── Main content — offset left by sidebar width, top by navbar height ── */}
      <main className="pl-24 pt-[100px] h-screen overflow-y-auto ">
        <div className="w-full p-4">
          <Outlet />
        </div>
      </main>

    </div>
  );
};

export default HomeNew;


// import React, { useEffect, useState } from "react";
// import "./HomeNew.css";
// import NavBar from "../Components/NavBar/NavBar";
// import SideBar from "../Components/SideBar";
// import { Outlet } from "react-router-dom";
// import { RxHamburgerMenu } from "react-icons/rx";
// import { useNavigate } from "react-router-dom";
// import NewSidebar from "../Components/NewComponents/NewSidebar";
// import NewSidebarOld from "../Components/NewComponents/NewSidebarOld";

// const HomeNew = () => {
//   const navigate = useNavigate();

//   //   const [showSideBar, setShowSideBar] = useState(false);
//   const [showSideBar, setShowSideBar] = useState(true);
//   const [shrinkSidePanel, setShrinkSidePanel] = useState(true);

//   const [showFullSidePanel, setShowFullSidePanel] = useState(false);
//   const [isModulePanelExpanded, setIsModulePanelExpanded] = useState(true);

//   const userData = JSON.parse(localStorage.getItem("BondTimeLoginUserData"));

//   // Check if user is logged in and has "Success" status
//   const isAuthenticated = userData && userData[0]?.Userlogin === "Sucess";

//   useEffect(() => {
//     if (!isAuthenticated) {
//       navigate("/");
//     }
//   }, [isAuthenticated]);

//   const toggleShowSideBar = () => {
//     setShowSideBar(!showSideBar);
//   };

//   const handleHomePage = () => {
//     window.scrollTo(0, 0);
//     navigate("/admin/home");
//   };

//   console.log("showSideBar", showSideBar);

//   return (
//     <>
//       <div className="HomeNewWrapper">
//         {/* sidebar */}
//         <div
//           className="HomeLeftCont"
//           style={{
//             width: shrinkSidePanel ? "7%" : "20%",
//           }}
//         >
//           <div>
//             <NewSidebarOld />
//           </div>
//         </div>

//         <div
//           className="HomeRightCont"
//           style={{
//             width: shrinkSidePanel ? "94%" : "80%",
//           }}
//         >
//           {/* navBar */}
//           <div className="">
//             <NavBar toggleShowSideBar={toggleShowSideBar} />
//           </div>

//           {/* outlet */}

//           <div className="OutletWrap">
//             <div className="NewDashBody main-body">
//               <Outlet />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default HomeNew;
